module.exports = __webpack_public_path__ + "img/logo-facebook.7ffda9b8.svg";